import '.j{display:flex;}.ssr-plugin'
import '.v{flex-direction:column;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.k{justify-content:center;}.ssr-plugin'
import '.as{min-height:100vh;}.ssr-plugin'
import '.ah{background-color:var(--shades-white);}.ssr-plugin'
import '.a2{padding:2rem;}.ssr-plugin'
import '.c{gap:2rem;}.ssr-plugin'
import '.f6{height:3rem;}.ssr-plugin'
import { styled } from 'inlines'
import fullLogo from '@app/assets/fullLogo.svg'
import { Text } from '@app/components/core/typography/Text'
import { Head } from '@based/sdk/react'
import { useTranslations } from '@i18n/useLanguage'

export const MaintenancePage = ({ message }: { message?: string }) => {
  const translations = useTranslations().app

  return (
    <div className="j v r k as ah a2 c"
    >
      <Head>
        <title>CrowdBuilding</title>
      </Head>
      <img className="f6"
        src={fullLogo}
        alt="CrowdBuilding"
      />
      <Text.Large
        style={{
          textAlign: 'center',
          maxWidth: '36rem',
        }}
      >
        {message || translations.landingPage.maintenanceMessage}
      </Text.Large>
    </div>
  )
}
